<template>
	<v-timeline dense class="job-timeline">
		<v-timeline-item hide-dot class="title">Pkg</v-timeline-item>
		<v-timeline-item small v-if="stat.pkgRequestStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(created)}}</v-col>
				<v-col cols="3" class="event">Queued</v-col>
				<v-col cols="4" class="code"><strong><span v-html="timeDuration(created, stat.pkgRequestStartTime)" /> QUEUE WAIT</strong></v-col>
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.pkgRequestStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.pkgRequestStartTime)}}</v-col>
				<v-col cols="3" class="event">Job Start</v-col>
				<v-col cols="4" class="code"><strong><span v-html="timeDuration(stat.pkgRequestStartTime, stat.pkgRequestEndTime)" /> JOB TOTAL</strong></v-col>
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.ingestionStartTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.ingestionStartTime)}}</v-col>
				<v-col cols="3" class="event">Ingestion</v-col>
				<v-col cols="3" class="code" v-html="timeDuration(stat.ingestionStartTime, stat.ingestionEndTime)" />
			</v-row>
		</v-timeline-item>
		<v-timeline-item small v-if="stat.pkgRequestEndTime">
			<v-row dense>
				<v-col cols="2" class="code">{{formatDateTime(stat.pkgRequestEndTime)}}</v-col>
				<v-col cols="3" class="event">Job End</v-col>
				<v-col cols="4" class="code"></v-col>
			</v-row>
		</v-timeline-item>
	</v-timeline>
</template>

<script>
export default {
	props: {
		stat: Object,
		created: String,
	},
	data() {
		return {};
	},
	methods: {
	},
};
</script>
